<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M4.66663 11.3337L11.3333 4.66699" stroke="#1B3729" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M4.66663 4.66699H11.3333V11.3337" stroke="#1B3729" stroke-linecap="round" stroke-linejoin="round"/>
</svg>